/**
 * @author: dwi.setiyadi@gmail.com
*/

import React from 'react';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  {
    path: '/users/temp',
    exact: true,
    name: 'Users Temp',
    component: React.lazy(() => import('./views/UsersTemp')),
  }
];

export default routes;
